import createReducer from '../../utils/createReducer';
import {
  CLEAR_LOGIN_USER_ERROR,
  LOGIN_USER_ERROR,
  LOGIN_USER_SUCCESS,
  LOGIN_USERNAMES_SUCCESS,
  RESET_LOGIN_STATE,
  SECURITY_QUESTION_ANSWER_ERROR,
  UPDATE_USER_JWT_TOKEN,
  LOGIN_USERNAMES_CLEAR,
  REGISTER_AUTHENTICATE_SUCCESS,
  REGISTER_AUTHENTICATE_ERROR,
  GENERATE_TOKEN_SUCCESS,
  GENERATE_TOKEN_ERROR,
  REGISTER_CONFIRM_AUTHENTICATION_SUCCESS,
  REGISTER_CONFIRM_AUTHENTICATION_ERROR,
  CLEAR_LOGIN_STATE,
} from '../../actions/login/loginActionConstants';

const initialState = {
  email: '',
  usernames: [],
  token: {
    RefreshToken: '',
    JwtToken: '',
  },
  TwoFactorAuthenticationResponse: '',
  registerToken: {
    RefreshToken: '',
    JwtToken: '',
  },
  errorMessage: '',
};

export default createReducer(
  {
    [LOGIN_USERNAMES_SUCCESS]: setUsernames,
    [LOGIN_USER_SUCCESS]: setUser,
    [UPDATE_USER_JWT_TOKEN]: setUserJwtToken,
    [RESET_LOGIN_STATE]: resetLoginState,
    [LOGIN_USER_ERROR]: setError,
    [SECURITY_QUESTION_ANSWER_ERROR]: setError,
    [CLEAR_LOGIN_USER_ERROR]: clearLoginErrors,
    [LOGIN_USERNAMES_CLEAR]: clearUsernames,
    [REGISTER_AUTHENTICATE_SUCCESS]: registerAuthenticateUser,
    [REGISTER_AUTHENTICATE_ERROR]: registerAuthenticateUserError,
    [REGISTER_CONFIRM_AUTHENTICATION_SUCCESS]: registerConfirmAuthenticationUser,
    [REGISTER_CONFIRM_AUTHENTICATION_ERROR]: registerConfirmAuthenticationUserError,
    [GENERATE_TOKEN_SUCCESS]: generateToken,
    [GENERATE_TOKEN_ERROR]: generateTokenError,
    [CLEAR_LOGIN_STATE]: clearLoginState,
  },
  initialState,
);

function setUsernames(state, action) {
  return {
    ...state,
    usernames: action.payload,
  };
}

function setUser(state, action) {
  const {
    JwtRefreshToken,
    JwtToken,
    RefreshToken,
    TwoFactorAuthenticationResponse,
  } = action.payload;
  return {
    ...state,
    token: {
      JwtRefreshToken,
      JwtToken,
      RefreshToken,
    },
    TwoFactorAuthenticationResponse,
  };
}

function setUserJwtToken(state, action) {
  return {
    ...state,
    token: {
      ...state.token,
      JwtToken: action.payload,
    },
  };
}

function setError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}

function resetLoginState() {
  return initialState;
}

function clearLoginErrors(state) {
  return {
    ...state,
    errorMessage: '',
  };
}

function clearUsernames() {
  return initialState;
}

function registerAuthenticateUser(state, action) {
  return {
    ...state,
    registerToken: action.payload,
  };
}

function registerAuthenticateUserError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}

function registerConfirmAuthenticationUser(state, action) {
  return {
    ...state,
    registerToken: action.payload,
  };
}

function registerConfirmAuthenticationUserError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}

function generateToken(state, action) {
  return {
    ...state,
    token: action.payload,
  };
}

function generateTokenError(state, action) {
  return {
    ...state,
    errorMessage: action.payload,
  };
}

function clearLoginState() {
  return initialState;
}
